export default __webpack_public_path__ + "static/5-35c06b2fdbcd78dfb581916f5dccc465.png";